// src/components/PassesQuiz.jsx
import React, { useEffect, useState } from "react";
import PassMapCard from "./PassMapCard";
import OptionsCard from "./OptionCard";

export const PASS_POINTS = [
  // Western & Peninsular India – Ghats / Gaps
  {
    name: "Thal Ghat (Kasara Ghat)",
    coordinates: [73.48, 19.67],
    state: "Maharashtra",
  },
  {
    name: "Bhor Ghat",
    coordinates: [73.37, 18.78],
    state: "Maharashtra",
  },
  {
    name: "Palghat Gap (Palakkad Gap)",
    coordinates: [76.58, 10.75],
    state: "Kerala / Tamil Nadu",
  },
  {
    name: "Shencottah Pass (Shenkotta Gap)",
    coordinates: [77.25, 8.98],
    state: "Tamil Nadu / Kerala",
  },

  // Kashmir–Ladakh side
  {
    name: "Burzil Pass (Burjila)",
    coordinates: [75.71, 35.12],
    state: "J&K (historic route)",
  },
  {
    name: "Pir Panjal Pass (Peer Ki Gali)",
    coordinates: [74.37, 33.6],
    state: "Jammu & Kashmir",
  },
  {
    name: "Zoji La (Jojila)",
    coordinates: [75.47, 34.28],
    state: "J&K / Ladakh",
  },
  {
    name: "Banihal Pass",
    coordinates: [75.16, 33.31],
    state: "Jammu & Kashmir",
  },

  // Himachal passes
  {
    name: "Rohtang Pass",
    coordinates: [77.24, 32.37],
    state: "Himachal Pradesh",
  },
  {
    name: "Baralacha La",
    coordinates: [77.43, 32.73],
    state: "Himachal Pradesh / Ladakh",
  },
  {
    name: "Shipki La",
    coordinates: [78.75, 31.82],
    state: "Himachal Pradesh / Tibet",
  },

  // High Himalayan
  {
    name: "Karakoram Pass",
    coordinates: [77.82, 35.51],
    state: "Ladakh / Xinjiang",
  },
  {
    name: "Mana Pass",
    coordinates: [79.4, 31.07],
    state: "Uttarakhand / Tibet",
  },
  {
    name: "Niti Pass",
    coordinates: [79.87, 30.97],
    state: "Uttarakhand / Tibet",
  },
  {
    name: "Lipulekh Pass",
    coordinates: [81.03, 30.23],
    state: "Uttarakhand / Tibet",
  },

  // Sikkim
  {
    name: "Jelep La (Jelepla)",
    coordinates: [88.87, 27.37],
    state: "Sikkim / Tibet",
  },
  {
    name: "Nathu La (Nathula)",
    coordinates: [88.83, 27.39],
    state: "Sikkim / Tibet",
  },

  // NE India
  {
    name: "Bomdila Pass",
    coordinates: [92.4, 27.25],
    state: "Arunachal Pradesh",
  },
  {
    name: "Yangyap (Yangapya) Pass",
    coordinates: [94.6, 28.1],
    state: "Arunachal Pradesh",
  },
  {
    name: "Tuju Pass",
    coordinates: [94.1, 24.3],
    state: "Manipur / Myanmar",
  },
];

function shuffleArray(arr) {
  return [...arr].sort(() => Math.random() - 0.5);
}

export default function PassesQuiz() {
  const [currentPass, setCurrentPass] = useState(null);
  const [correctLabel, setCorrectLabel] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isCorrect, setIsCorrect] = useState(null);
  const [questionNumber, setQuestionNumber] = useState(1);

  const [vw, setVw] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const h = () => setVw(window.innerWidth);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const isMobile = vw <= 768;
  const mapScale = isMobile ? 850 : 650;

  const generateQuestion = () => {
    if (!PASS_POINTS.length) return;

    const correct =
      PASS_POINTS[Math.floor(Math.random() * PASS_POINTS.length)];

    const others = PASS_POINTS.filter((p) => p.name !== correct.name);
    const distractors = shuffleArray(others).slice(0, 3);

    const opts = shuffleArray([
      correct.name,
      ...distractors.map((d) => d.name),
    ]);

    setCurrentPass(correct);
    setCorrectLabel(correct.name);
    setOptions(opts);
    setSelectedAnswer(null);
    setIsCorrect(null);
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const loading = !currentPass || !options.length;

  const goNext = () => {
    setQuestionNumber((q) => q + 1);
    generateQuestion();
  };

  const handleAnswer = (answer) => {
    if (!correctLabel || selectedAnswer) return;

    setSelectedAnswer(answer);
    const ok = answer === correctLabel;
    setIsCorrect(ok);

    // Auto-next removed – ab sirf Next se aage
  };

  return (
    <div className="quiz-body">
      <PassMapCard
        currentPass={currentPass}
        questionNumber={questionNumber}
        loading={loading}
        mapScale={mapScale}
      />

      <OptionsCard
        mode="passes"
        options={options}
        correctLabel={correctLabel}
        selectedAnswer={selectedAnswer}
        isCorrect={isCorrect}
        loading={loading}
        onAnswer={handleAnswer}
        onNext={goNext}
      />
    </div>
  );
}
